import { createStore, Store, compose } from 'redux';
import rootReducer from './reducer';

// Simple store without Redux DevTools to avoid BroadcastChannel errors
// DevTools can be re-enabled once the issue is resolved
const store: Store = createStore(rootReducer);
export default store;
